export enum IntegrationCategory {
  ACCOUNTING = 'ACCOUNTING',
  CRM = 'CRM',
  PAYMENT = 'PAYMENT',
  METERING = 'METERING',
}
